import { RefObject } from 'react';
import { ToastProps, Typography, useToaster } from '@prenuvo/halo-foundation';

import { ErrorWithoutBackground } from '@/assets/icons';

interface ToastHandlerArgs extends ToastProps {
  toastRef: RefObject<HTMLSpanElement>;
}

export function useToastHandler({
  className,
  description,
  title,
  toastRef,
  variant = 'error',
}: ToastHandlerArgs) {
  const { addToast } = useToaster();

  return () => {
    if (toastRef.current) {
      return;
    }

    addToast({
      className,
      description: (
        <span className="flex flex-row gap-4 p-1" ref={toastRef}>
          <img alt="missing input" src={ErrorWithoutBackground} />
          <Typography className="text-red-500 dark:text-red-500">{description}</Typography>
        </span>
      ),
      duration: 3000,
      title,
      variant,
    });
  };
}
